import axios, { type AxiosRequestConfig } from 'axios';
import { getCookie } from '@/shared/lib/cookies';

const AUTH_COOKIE = 'admin_auth_token';

export const apiClient = axios.create({
  baseURL: __CONFIG__.API_URL,
  timeout: 60_000,
});

apiClient.interceptors.request.use((config) => {
  const url = config.url || '';
  // Login / refresh must not attach a stale access token
  if (url.includes('/user/auth/') || url.includes('/user/refresh-token/')) return config;

  const token = getCookie(AUTH_COOKIE);
  if (!token) return config;

  if (config.data instanceof FormData) {
    if (!config.data.has('auth_token')) config.data.append('auth_token', token);
    return config;
  }
  if (config.method?.toLowerCase() === 'get') {
    config.params = { ...config.params, auth_token: token };
    return config;
  }
  if (config.data && typeof config.data === 'object') {
    config.data = { ...config.data, auth_token: token };
  }
  return config;
});

export type FormFields = Record<
  string,
  string | number | boolean | Blob | null | undefined | Array<string | number>
>;

export async function postForm<T = unknown>(
  url: string,
  fields: FormFields = {},
  config?: AxiosRequestConfig,
): Promise<T> {
  const body = new FormData();
  Object.entries(fields).forEach(([key, value]) => {
    if (value === null || value === undefined || value === '') return;
    if (Array.isArray(value)) {
      value.forEach((item) => body.append(`${key}[]`, String(item)));
      return;
    }
    if (typeof value === 'number' || typeof value === 'boolean') {
      body.append(key, String(Number(value)));
      return;
    }
    body.append(key, value);
  });
  const { data } = await apiClient.post<T>(url, body, config);
  return data;
}
